export default __webpack_public_path__ + "static/media/U.82615fe9.png";